import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function PendingFiltersBar({
  locationsList,
  locationFilter, setLocationFilter,
  phoneFilter, setPhoneFilter,
  bookingRefFilter, setBookingRefFilter,
  emailFilter, setEmailFilter,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  applyDateFilters, clearFilters,
}) {
  const hasActive =
    dateFrom || dateTo || locationFilter !== 'all' ||
    phoneFilter || bookingRefFilter || emailFilter;

  return (
    <Card className="px-3 py-2 mb-4">
      <div className="flex flex-wrap items-center gap-2">
        <Select value={locationFilter} onValueChange={setLocationFilter}>
          <SelectTrigger className="w-44 h-9" data-testid="location-filter">
            <SelectValue placeholder="All Locations" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Locations</SelectItem>
            {locationsList.map((loc) => (
              <SelectItem key={loc.id} value={loc.id}>{loc.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          type="text"
          value={phoneFilter}
          onChange={(e) => setPhoneFilter(e.target.value)}
          placeholder="Phone…"
          className="w-36 h-9"
          data-testid="phone-filter"
        />
        <Input
          type="text"
          value={bookingRefFilter}
          onChange={(e) => setBookingRefFilter(e.target.value)}
          placeholder="Booking Ref"
          className="w-36 h-9"
          data-testid="booking-ref-filter"
        />
        <Input
          type="text"
          value={emailFilter}
          onChange={(e) => setEmailFilter(e.target.value)}
          placeholder="Email…"
          className="w-44 h-9"
          data-testid="email-filter"
        />
        <Input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          placeholder="From"
          title="From date"
          className="w-44 h-9"
          data-testid="date-from-filter"
        />
        <Input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          placeholder="To"
          title="To date"
          className="w-44 h-9"
          data-testid="date-to-filter"
        />
        <Button
          size="sm"
          onClick={applyDateFilters}
          className="bg-emerald-700 hover:bg-emerald-800 text-white"
          data-testid="apply-filters-btn"
        >
          Apply
        </Button>
        {hasActive && (
          <Button
            size="sm"
            variant="ghost"
            onClick={clearFilters}
            data-testid="clear-filters-btn"
          >
            Clear
          </Button>
        )}
      </div>
    </Card>
  );
}
